import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import Landing from '../side-panels/ProcoreSidePanels/Landing';
import ProcoreOauthSuccess from '../side-panels/ProcoreSidePanels/ProcoreOauthSuccess';
import ProjectRecordsLanding from '../side-panels/ProcoreSidePanels/ProjectRecordsLanding';

const SidePanels = ({ ...props }) => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route
        exact
        component={Landing}
        path={`${path}/procore/landing`}
      />
      <Route
        exact
        component={ProcoreOauthSuccess}
        path={`${path}/procore/oauth/callback`}
      />
      <Route
        exact
        component={ProjectRecordsLanding}
        path={`${path}/procore/project-records`}
      />
    </Switch>
  );
};

export default SidePanels;
